// Send the waitlist signup to the SendWrench platform as well as to Shopify.
//
// BOTH, deliberately. Shopify's contact form still submits normally and still emails, because it
// is the fallback: if the platform is mid-deploy or the request fails, the lead lands in an inbox
// instead of nowhere. Losing a signup is the worst thing this site can do, so it is worth sending
// twice and de-duplicating later.
//
// The POST is fired with keepalive so the browser finishes it even though the form is navigating
// away in the same tick. Nothing is awaited and nothing can block the submit — if the platform is
// unreachable, the user still gets their confirmation from Shopify and never sees a difference.
(function () {
  var ENDPOINT = 'https://app.sendwrench.com/api/waitlist';
  var MESSAGE_ENDPOINT = 'https://app.sendwrench.com/api/message';

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el && el.value ? el.value.trim() : null;
  }

  function init(form) {
    if (form.dataset.swRelayReady) return;
    form.dataset.swRelayReady = '1';

    var shownAt = Date.now();

    form.addEventListener('submit', function () {
      try {
        var emailBox = form.querySelector('[name="contact[email updates]"]');
        var smsBox = form.querySelector('[name="contact[text updates]"]');
        var consent = form.closest('.sw') ? form.closest('.sw').querySelector('.sw-consent') : null;

        // The wording as it stood on the day, so what somebody agreed to is stored with their
        // answer rather than inferred later from whatever the page says by then.
        // Email consent is the act of signing up now; the fine print says so and is captured
        // as the record. The SMS box remains a real box until the A2P campaign clears review.
        var parts = [];
        if (smsBox && smsBox.checked) parts.push(text(smsBox));
        var fine = consent ? consent.querySelector('.sw-consent__fine') : null;
        if (fine) parts.push(fine.textContent.trim());
        var wording = parts.filter(Boolean).join('\n\n') || null;

        var payload = {
          name: val(form, 'contact[name]'),
          shop_name: val(form, 'contact[shop name]'),
          email: val(form, 'contact[email]'),
          phone: val(form, 'contact[phone]'),
          techs: val(form, 'contact[techs]'),
          current_software: val(form, 'contact[current software]'),
          message: val(form, 'contact[body]'),
          email_consent: true,
          sms_consent: !!(smsBox && smsBox.checked),
          consent_wording: wording,
          page: location.pathname,
          referrer: document.referrer || null,
          company_website: val(form, 'company_website'),
          elapsed_ms: Date.now() - shownAt,
        };

        if (!payload.email) return;

        // Texting is deliberately not gated here: it is optional by design and by
        // 47 CFR 64.1200(a)(2), which forbids making it a condition of the service.

        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
          mode: 'cors',
        }).catch(function () { /* Shopify's own submit is the fallback; never block on this */ });
      } catch (e) {
        /* Anything thrown here must not stop the form submitting. */
      }
    });
  }

  function text(box) {
    var row = box.closest('.sw-consent__row');
    var t = row ? row.querySelector('.sw-consent__text') : null;
    return t ? t.textContent.trim() : null;
  }

  /**
   * The contact and change-request forms. Same belt-and-braces as the waitlist: Shopify still
   * submits and still emails, and this is the copy that reaches the console. No consent is read
   * or sent — asking a question is not agreeing to be marketed to, and there is no field here
   * that could make it look like it was.
   */
  function initMessage(form) {
    if (form.dataset.swRelayReady) return;
    form.dataset.swRelayReady = '1';
    var shownAt = Date.now();
    var kind = form.getAttribute('data-sw-message') === 'request' ? 'request' : 'contact';

    form.addEventListener('submit', function () {
      try {
        var payload = {
          kind: kind,
          name: val(form, 'contact[name]'),
          shop_name: val(form, 'contact[shop name]'),
          email: val(form, 'contact[email]'),
          phone: val(form, 'contact[phone]'),
          subject: val(form, 'contact[about]') || val(form, 'contact[request type]'),
          priority: val(form, 'contact[priority]'),
          body: val(form, 'contact[body]'),
          workaround: val(form, 'contact[workaround]'),
          page: location.pathname,
          referrer: document.referrer || null,
          company_website: val(form, 'company_website'),
          elapsed_ms: Date.now() - shownAt
        };
        if (!payload.body) return;

        fetch(MESSAGE_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
          mode: 'cors'
        }).catch(function () { /* Shopify's own submit is the fallback; never block on this */ });
      } catch (e) {
        /* Anything thrown here must not stop the form submitting. */
      }
    });
  }

  function boot() {
    document.querySelectorAll('form[data-sw-waitlist]').forEach(init);
    document.querySelectorAll('form[data-sw-message]').forEach(initMessage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
